import { Pipe, PipeTransform } from '@angular/core';

import { SharedLinkResponse } from 'src/models/shared-link.model';

@Pipe({
  name: 'extractPaymentLinkUuid',
  standalone: true,
  pure: true,
})
export class ExtractPaymentLinkUuidPipe implements PipeTransform {

  private readonly uuidRegex = /\/shared-link\/([a-f0-9-]+)/;

  transform(content: string, cache: Map<string, SharedLinkResponse>): string | null {
    if (!content) {
      return null;
    }
    const match = content.match(this.uuidRegex);
    if (!match) {
      return null;
    }
    const uuid = match[1];
    if (!cache) {
      return uuid;
    }
    const data = cache.get(uuid);
    if (!data) {
      return uuid;
    }
    if (data.shared_link_data?.expired) {
      return null;
    }
    if (data.shared_link_data?.action_type !== 'ai_task_add_payment_method') {
      return null;
    }
    return uuid;
  }
}
